module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', {
    staticClass: "bg-gray-100 min-h-screen flex flex-col"
  }, [_c('div', {
    staticClass: "bg-gradient-to-b from-secondary to-primary"
  }, [_c('app-header', {
    staticClass: "!hidden",
    attrs: {
      "icon": "factory"
    }
  }, [_vm._v("Ajout détenteur")]), _vm._v(" "), _c('header', {
    staticClass: "text-white pt-4 pb-12 px-4 flex items-center justify-between"
  }, [_c('h1', {
    staticClass: "text-2xl flex items-center gap-3"
  }, [_c('router-link', {
    staticClass: "inline-flex items-center justify-center h-10 w-10 rounded-lg bg-white/15 hover:bg-white/25 transition",
    attrs: {
      "to": {
        name: 'liste-detenteurs'
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-arrow-left bg-white"
  })]), _vm._v(" "), _c('span', [_vm._v("Ajout détenteur")])], 1), _vm._v(" "), _c('span', {
    staticClass: "opacity-0 select-none"
  }, [_vm._v(".")])])], 1), _vm._v(" "), _c('main', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 shadow-xl pb-28"
  }, [_c('div', {
    staticClass: "m-2 shadow-2xl rounded-lg overflow-hidden mb-24"
  }, [_c('div', {
    staticClass: "bg-white p-4"
  }, [_c('form', {
    staticClass: "space-y-6",
    attrs: {
      "method": "post",
      "id": "detenteur"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendForm($event)
      }
    }
  }, [_c('div', [_c('h2', {
    staticClass: "text-lg font-medium mb-4 uppercase text-secondary"
  }, [_vm._v("Informations générales")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.type),
      expression: "type",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "name": "type",
      "id": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("Société")]), _vm._v(" "), _c('option', [_vm._v("Particulier")]), _vm._v(" "), _c('option', [_vm._v("Association")])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Code client")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.code_client),
      expression: "code_client",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "title": "clientCode",
      "name": "code-client",
      "id": "code-client",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.code_client)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code_client = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "md:col-span-2"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n                                    Raison sociale / Nom "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.raison_sociale),
      expression: "raison_sociale",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "title": "company",
      "name": "raison_sociale",
      "id": "raison_sociale",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.raison_sociale)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.raison_sociale = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.type !== 'Particulier'),
      expression: "this.type !== 'Particulier'"
    }]
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("SIRET")]), _vm._v(" "), _c('cleave', {
    staticClass: "input",
    attrs: {
      "options": _vm.siretOpt,
      "name": "siret",
      "id": "siret",
      "type": "text"
    },
    model: {
      value: (_vm.siret),
      callback: function($$v) {
        _vm.siret = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "siret"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-4"
  }, [(_vm.suggestion) ? _c('div', {
    staticClass: "md:col-span-2 flex items-center gap-3 rounded-lg border border-blue-200 bg-blue-50 px-3 py-2 text-sm text-blue-700"
  }, [_c('i', {
    staticClass: "inline-block h-4 w-4 shrink-0 mask mask-location bg-blue-500"
  }), _vm._v(" "), _c('span', {
    staticClass: "flex-1 truncate"
  }, [_vm._v(_vm._s(_vm.suggestion.preview))]), _vm._v(" "), _c('button', {
    staticClass: "shrink-0 font-medium underline underline-offset-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.applySuggestion
    }
  }, [_vm._v("Utiliser")]), _vm._v(" "), _c('button', {
    staticClass: "shrink-0 opacity-50 hover:opacity-100 text-base leading-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.suggestion = null
      }
    }
  }, [_vm._v("✕")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "md:col-span-2"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n                                    Adresse "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.adresse),
      expression: "adresse",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "title": "address",
      "name": "adresse",
      "id": "adresse",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.adresse)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.adresse = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "md:col-span-2"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Complément d'adresse")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.complement_adresse),
      expression: "complement_adresse",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "title": "moreAddress",
      "name": "completemnt_adresse",
      "id": "completemnt_adresse",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.complement_adresse)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.complement_adresse = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n                                    Code postal "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('cleave', {
    staticClass: "input",
    attrs: {
      "options": _vm.cpOpt,
      "name": "adresse_cp",
      "id": "adresse_cp",
      "type": "text"
    },
    model: {
      value: (_vm.code_postal),
      callback: function($$v) {
        _vm.code_postal = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "code_postal"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n                                    Ville "), _c('span', {
    staticClass: "text-alert"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ville),
      expression: "ville",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "title": "city",
      "name": "adresse_ville",
      "id": "adresse_ville",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.ville)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ville = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4 mt-4"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Téléphone")]), _vm._v(" "), _c('cleave', {
    staticClass: "input",
    attrs: {
      "options": _vm.telOpt,
      "name": "telephone",
      "id": "telephone",
      "type": "text",
      "inputmode": "tel"
    },
    model: {
      value: (_vm.telephone),
      callback: function($$v) {
        _vm.telephone = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "telephone"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n                                    Email "), _c('span', {
    staticClass: "text-[11px] text-gray-500"
  }, [_vm._v("(réception des fiches)")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "title": "email",
      "name": "email",
      "id": "email",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "text-lg font-medium mb-4 uppercase text-secondary"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-4"
  }, [_c('div', {
    staticClass: "md:col-span-2"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nom / Prénom")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.nom),
      expression: "nom",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "title": "fullName",
      "name": "nom_contact",
      "id": "nom_contact",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.nom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nom = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Téléphone portable")]), _vm._v(" "), _c('cleave', {
    staticClass: "input",
    attrs: {
      "options": _vm.telOpt,
      "name": "tel_contact",
      "id": "tel_contact",
      "type": "text",
      "inputmode": "tel"
    },
    model: {
      value: (_vm.portable),
      callback: function($$v) {
        _vm.portable = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "portable"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Ligne directe")]), _vm._v(" "), _c('cleave', {
    staticClass: "input",
    attrs: {
      "options": _vm.telOpt,
      "name": "ligne_directe_contact",
      "id": "ligne_directe_contact",
      "type": "text",
      "inputmode": "tel"
    },
    model: {
      value: (_vm.direct),
      callback: function($$v) {
        _vm.direct = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "direct"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "pt-2"
  }, [_c('button', {
    staticClass: "w-full sm:w-auto bg-primary text-white font-semibold tracking-wide px-5 py-3 rounded-xl shadow hover:shadow-md active:scale-[0.99] transition",
    attrs: {
      "type": "submit",
      "name": "new"
    }
  }, [_vm._v("\n                            AJOUTER\n                        ")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05f04b70","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detenteur/NewDetenteur.vue
// module id = 999
// module chunks = 0